import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/home";
import HomeTwo from "./pages/home-2";
import HomeThree from "./pages/home-3";
import HomeFour from "./pages/home-4";
import About from "./pages/about";
import Team from "./pages/team";
import TeamDetails from "./pages/team-details";
import Testimonials from "./pages/testimonials";
import Faq from "./pages/faq";
import NoPage from "./pages/NoPage";
import Services from "./pages/services";
import Peak from "./pages/movable-excavator";
import FixedBoomExcavator from "./pages/fixed-boom-excavator";
import DoubleShaft from "./pages/double-shaft-shredder";
import HydraulicScrap from "./pages/hydraulic-scrap-baler";
import Reliable from "./pages/horizontal-automatic-container-shear";
import Restoration from "./pages/top-notch-roofing-restoration";
import Project from "./pages/project";
import ProjectDetails from "./pages/project-details";
import Blog from "./pages/blog";
import Bloglist from "./pages/blog-list";
import BlogDetails from "./pages/blog-details";
import Contact from "./pages/contact";
import ScrapMagnetMachine from "./pages/scrap-magnet";
import ScrapGrabber from "./pages/grabber";
import VerticalheavyScrapShear from "./pages/VerticalScrapShear";




export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route index element={<Home />} />
        <Route path="*" element={<NoPage />} />

        <Route path="about" element={<About />} />

        <Route path="products" element={<Services />} />
        <Route path="scrap-magnet" element={<ScrapMagnetMachine />} />
        <Route path="movable-excavator" element={<Peak />} />
        <Route path="fixed-boom-excavator" element={<FixedBoomExcavator />} />
        <Route path="double-shaft-shredder" element={<DoubleShaft />} />
        <Route path="grabber" element={<ScrapGrabber />} />
        <Route path='vertical-scrap-shear' element={<VerticalheavyScrapShear />} />
        <Route path="hydraulic-scrap-baler" element={<HydraulicScrap />} />
        <Route path="horizontal-automatic-container-shear" element={<Reliable />} />
        <Route path="contact" element={<Contact />} />
      </Routes>
    </BrowserRouter>
  );
}
